<template>
    <div class="relative portfolio-min-height">
            <page-header class="portfolio-header"/>
            <side-nav class="portfolio-side-nav"/>
        <div class="page page-highlights d-flex" id="highlights">
            <div class="row align-items-center text-center w-100 no-gutters">
                <a href="https://smartdevicelink.com" target="_blank" class="col-12 col-md-4 sdl">
                    <img class="highlight portfolio-min-height" src="../../static/images/1x/sdl_image.png" srcset="../../static/images/2x/sdl_image@2x.png 2x, ../../static/images/3x/sdl_image@3x.png 3x"/>
                    <img class="focus" src="../../static/images/1x/sdl_logo.png" srcset="../../static/images/2x/sdl_logo@2x.png 2x, ../../static/images/3x/sdl_logo@3x.png 3x" />
                </a>
                <a href="https://music.livio.io" target="_blank" class="col-12 col-md-4 liviomusic">
                    <img class="highlight portfolio-min-height" src="../../static/images/1x/lmp_image.png" srcset="../../static/images/2x/lmp_image@2x.png 2x, ../../static/images/3x/lmp_image@3x.png 3x"/>
                    <img class="focus" src="../../static/images/1x/lmp_logo.png" srcset="../../static/images/2x/lmp_logo@2x.png 2x, ../../static/images/3x/lmp_logo@3x.png 3x" />
                </a>
                <a href="https://github.com/smartdevicelink" target="_blank" class="col-12 col-md-4 github">
                    <img class="highlight portfolio-min-height" src="../../static/images/1x/github_image.png" srcset="../../static/images/2x/github_image@2x.png 2x, ../../static/images/3x/github_image@3x.png 3x"/>
                    <img class="focus" src="../../static/images/1x/gh_logo.png" srcset="../../static/images/2x/gh_logo@2x.png 2x, ../../static/images/3x/gh_logo@3x.png 3x" />
                </a>
            </div>
        </div>
    </div>
</template>
<script>

import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
import SideNav from './shared/SideNav.vue'
export default {
    data () {
        return {
        }
    },
    components: {
        "page-footer": Footer,
        "page-header": Header,
        "side-nav": SideNav,
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Portfolio.vue